import { combineReducers } from 'redux';

import dashboard from './dashboard';
import intervention from './intervention';
import loadingByLead from './loadingByLead';
import modals from './modals';

export default combineReducers({
  modals,
  dashboard,
  intervention,
  loadingByLead,
});
